export const getCurrentLocale = () =>
  globalThis?.window?.chatwootConfig?.selectedLocale ||
  globalThis?.document?.documentElement?.lang ||
  'en';
